import React from "react";

// set the defaults
const ThemeContext = React.createContext<{
theme: string, setTheme: (newTheme: string) => void }> ({
  theme: "dark",
  setTheme: function (newTheme: string): void {
    this.theme = newTheme;
  }
});

export default ThemeContext;
